import { ApplicationFormValues } from '../../../../../LoanDetailTypes';
import { Rule } from '../../../interfaces/Rule';
import { Ruleset } from '../../../interfaces/Ruleset';
import { RulesetResult, IsPropertyLeased } from '../../rules';
import { BaseRuleset } from '../BaseRuleset';

export class PropertyLeaseExpirationYearRuleset
  extends BaseRuleset
  implements Ruleset
{
  protected rules: Rule[] = [IsPropertyLeased];

  public evaluate(data: Partial<ApplicationFormValues>): RulesetResult {
    const isLeased = IsPropertyLeased.evaluate(data);
    return isLeased ? RulesetResult.REQUIRED : RulesetResult.HIDDEN;
  }
}

export default new PropertyLeaseExpirationYearRuleset();
